import { render } from "./PurchaseActions.vue?vue&type=template&id=3981774d"
import script from "./PurchaseActions.vue?vue&type=script&lang=js"
export * from "./PurchaseActions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__